var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-selection-container",class:_vm.clazz},[_c('span',{staticClass:"icon-card"},[_vm._t("icon")],2),_c('span',[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_vm._t("extraMiddleContent")],2),_c('span',[_vm._t("extraFinalContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }